<template>
  <article class="px-2 py-4">
    <h3 class="font-bold py-6">{{ listing.job_title }}</h3>
    <ul class="dark-text">
      <li>
        <span class="font-bold">Role Type:</span>
        {{ listing.role_type }}
      </li>
      <li v-if="listing.compensation">
        <span class="font-bold">Compensation:</span>
        {{ formattedCompensation }}
      </li>
      <li v-if="listing.date_updated">
        <span class="font-bold">Posted:</span>
        {{ formattedDate }}
      </li>
    </ul>
    <div class="py-6">
      <h4 class="font-bold py-6 text-xl">About the Company</h4>
      <div v-html="listing.about_the_company"></div>
    </div>
    <div>
      <h4 class="font-bold py-6 text-xl">Job Description</h4>
      <div v-html="listing.job_description"></div>
    </div>
    <div class="py-6">
      <h4 class="font-bold py-6 text-xl">Qualifications</h4>
      <div class="dark-text">
        Past experiences should include:
        <ul class="custom-list pt-4">
          <li v-for="(one, index) of qualitifcationList" :key="index">
            {{ one }}
          </li>
        </ul>
      </div>
      <div class="dark-text pt-6" v-if="listing.screening_questions">
        Screening Questions:
        <ol class="list-decimal ml-4 pt-2 space-y-1">
          <li
            v-for="(one, index) of screeningQuestions"
            :key="index"
            class="pl-2"
          >
            {{ one }}
          </li>
        </ol>
      </div>
    </div>
    <button
      class="btn btn-primary"
      data-tally-open="w2r6gj"
      data-tally-layout="modal"
      data-tally-width="840"
      data-tally-auto-close="3000"
      :data-selected_job="listing.job_title"
    >
      Apply
    </button>
  </article>
</template>

<script setup lang="ts">
interface Props {
  listing: JobListing;
}
const { listing } = defineProps<Props>();
const formattedCompensation = `$${Number(
  listing.compensation
).toLocaleString()}`;
const date = listing.date_updated ? new Date(listing.date_updated) : null;
const formattedDate = date?.toDateString();
const applicationLink = listing.job_id
  ? `https://www.linkedin.com/jobs/search/?currentJobId=${listing.job_id}`
  : `/contact`;
const qualitifcationList = listing.qualifications.split("\n");
const screeningQuestions = listing.screening_questions.split("\n");
</script>
